import type { Meta, StoryFn } from '@storybook/react';
import type { PropsWithChildren } from 'react';
import type { FieldsetProps } from './Fieldset';

import { Fieldset } from './Fieldset';

import { InputField } from 'components/InputField';
import { Label } from 'components/Label';
import { Container } from 'storyComponents/Container';
import { FormField } from 'components/FormField';

const codeString = '<Fieldset legend={legend} description={description}>{children}</Fieldset>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Fieldset',
  component: Fieldset,
  argTypes: {
    descriptionId: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Fieldset,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<FieldsetProps>>;

const Template: StoryFn<PropsWithChildren<FieldsetProps>> = (args) => (
  <Container size="large">
    <Fieldset {...args}>
      <FormField>
        <Label htmlFor="d6aa53fd">Example label 1</Label>
        <InputField id="d6aa53fd" />
      </FormField>
      <FormField>
        <Label htmlFor="4e7a2f22">Example label 2</Label>
        <InputField id="4e7a2f22" />
      </FormField>
    </Fieldset>
  </Container>
);

const defaultArgs: Partial<PropsWithChildren<FieldsetProps>> = {
  legend: 'Fieldset example',
  inline: false,
};

export const FieldsetExample = Template.bind({});
FieldsetExample.args = {
  ...defaultArgs,
};

export const WithDescriptionExample = Template.bind({});
WithDescriptionExample.args = {
  ...defaultArgs,
  description: 'A Fieldset groups several controls as well as labels',
};
